/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import { registerGlobalComponents } from "./global-components";

// Own global mixins
import DateMixin from "./classes/DateMixin";

import { useAuthService } from "@/services/AuthService";
import { initializeApp } from "firebase/app";
import { BotStore } from "./store/constants";
const firebaseApp = initializeApp({
  apiKey: "AIzaSyDktLWA1tUXZNSzBwykFB31IzgPLnHu1qU",
  authDomain: "caderio-neu.firebaseapp.com",
  databaseURL: "https://caderio-neu.firebaseio.com",
  projectId: "caderio-neu",
  storageBucket: "caderio-neu.appspot.com",
  messagingSenderId: "854993856946",
  appId: "1:854993856946:web:16f5fd5d52112eb1e51cab",
  measurementId: "G-25QXBLF85L"
});

// import { getAnalytics } from "firebase/analytics"; //TODO only in prod

const app = createApp(App);
registerGlobalComponents(app);

// Register own global mixins
app.use(store).use(router).mount("#app");
app.mixin(DateMixin);

document.title = "ChatCaptain";

// useAuthService(); moved to Router

// const analytics = getAnalytics(app); //TODO only in prod